/* eslint-disable import/prefer-default-export */
export const IMPLICIT_ROLES = {
  a: 'link',
  area: 'link',
  article: 'article',
  aside: 'complementary',
  button: 'button',
  details: 'group',
  dfn: 'term',
  dialog: 'dialog',
  fieldset: 'group',
  figure: 'figure',
  footer: 'contentinfo',
  form: 'form',
  h1: 'heading',
  h2: 'heading',
  h3: 'heading',
  h4: 'heading',
  h5: 'heading',
  h6: 'heading',
  header: 'banner',
  hr: 'separator',
  iframe: 'document',
  img: 'img',
  input: null, // for type purposes this value needs to be included
  li: 'listitem',
  main: 'main',
  menu: 'list',
  menuitem: 'menuitem',
  meter: 'meter',
  nav: 'navigation',
  ol: 'list',
  option: 'option',
  progress: 'progressbar',
  section: 'region',
  select: 'listbox',
  summary: 'button',
  table: 'table',
  tbody: 'rowgroup',
  td: 'cell',
  textarea: 'textbox',
  tfoot: 'rowgroup',
  th: 'columnheader',
  thead: 'rowgroup',
  tr: 'row',
  ul: 'list',
} as const

export const INPUT_TYPE_ROLES = {
  button: 'button',
  checkbox: 'checkbox',
  radio: 'radio',
  range: 'slider',
  text: 'textbox',
  password: 'textbox',
  email: 'textbox',
  search: 'searchbox',
  number: 'spinbutton',
  tel: 'textbox',
  url: 'textbox',
  submit: 'button',
  reset: 'button',
  image: 'button',
  file: 'textbox',
} as const
